import { useLocation } from 'react-router';

import { sharedAcrossSportsPage } from '#src/constants/routes.ts';

export const useSharedAcrossSportsPage = () => {
  const location = useLocation();

  return sharedAcrossSportsPage(location.pathname);
};
